import { render, staticRenderFns } from "./SchoolAwayDetailCreateForm.vue?vue&type=template&id=604e141c&scoped=true&"
import script from "./SchoolAwayDetailCreateForm.vue?vue&type=script&lang=js&"
export * from "./SchoolAwayDetailCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e141c",
  null
  
)

export default component.exports